// extracted by mini-css-extract-plugin
export var container = "_4j-0";
export var disabled = "_4j-4";
export var fullWidth = "_4j-3";
export var lined = "_4j-1";
export var selected = "_4j-5";
export var tab = "_4j-2";